module.exports = __webpack_public_path__ + "static/media/pmg_icon.2999c41f.svg";